import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/image/3333.svg'


const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "register-link" }

import { ref } from 'vue'
import { useAuth } from '@/composables/useAuth'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const { login } = useAuth()
const username = ref('')
const password = ref('')

const handleLogin = () => login(username.value, password.value)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("img", {
      src: _imports_0,
      alt: "FiftyFifty 로고",
      class: "logo"
    }, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("h2", null, "로그인", -1)),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
      placeholder: "아이디",
      class: "input"
    }, null, 512), [
      [_vModelText, username.value]
    ]),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
      type: "password",
      placeholder: "비밀번호",
      class: "input"
    }, null, 512), [
      [_vModelText, password.value]
    ]),
    _createElementVNode("button", {
      class: "login-btn",
      onClick: handleLogin
    }, " 로그인 "),
    _createElementVNode("p", _hoisted_2, [
      _cache[3] || (_cache[3] = _createTextVNode(" 아직 회원이 아니신가요? ")),
      _createVNode(_component_router_link, { to: "/register" }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode(" 회원가입 ")
        ])),
        _: 1,
        __: [2]
      })
    ])
  ]))
}
}

})